export default {
    error: false,
    loading: {
        module:false,
    },
    message_loading : 'Cargando Plantilla De Incorporación De Saldos Contables',
    file: ''
};



// WEBPACK FOOTER //
// ./src/modules/import-saldos-contables/state.js